"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _app = require("@package/app");

var notifications = _interopRequireWildcard(require("@package/notifications"));

var _storybook = require("@pikassa/storybook");

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _classnames = _interopRequireDefault(require("classnames"));

var _defaultModule = _interopRequireDefault(require("./default.module.scss"));

function InvoiceUrlSuccess(_ref) {
  var _data = _ref._data,
      data = _ref.data;

  try {
    var handleToClipboard = function handleToClipboard() {
      var el = document.createElement('textarea');
      el.value = data['paymentLink'];
      el.setAttribute('readonly', '');
      el.style.position = 'absolute';
      el.style.left = '-9999px';
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
      dispatch(notifications.push({
        title: 'Ссылка успешно скопирована',
        mode: 'success'
      }));
    };

    var dispatch = (0, _reactRedux.useDispatch)();
    var iconClassName = (0, _classnames["default"])(_defaultModule["default"]['icon'], 'icon-success');
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['success']
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['thumb']
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: iconClassName
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['header']
    }, /*#__PURE__*/_react["default"].createElement(_storybook.Header, {
      level: 4,
      "data-locator": "".concat(_data, ".message")
    }, "\u0421\u0447\u0435\u0442 \u2116", data['externalId'], " \u0432\u044B\u0441\u0442\u0430\u0432\u043B\u0435\u043D")), /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['content']
    }, /*#__PURE__*/_react["default"].createElement(_storybook.Text, {
      type: 'body',
      "data-locator": "".concat(_data, ".information")
    }, "\u0421\u0447\u0435\u0442 \u043D\u0430 \u043E\u043F\u043B\u0430\u0442\u0443 \u0434\u043E\u0441\u0442\u0443\u043F\u0435\u043D \u043F\u043E \u0441\u0441\u044B\u043B\u043A\u0435:"), /*#__PURE__*/_react["default"].createElement("a", {
      className: _defaultModule["default"]['link'],
      "data-locator": "".concat(_data, ".link"),
      rel: "noopener noreferrer",
      target: "_blank",
      href: data['paymentLink']
    }, data['paymentLink'])), /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['controls']
    }, /*#__PURE__*/_react["default"].createElement(_storybook.Button, {
      "data-locator": "save_url_button",
      form: "outline",
      mode: "primary",
      onClick: function onClick() {
        return handleToClipboard();
      }
    }, "\u0421\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0441\u0441\u044B\u043B\u043A\u0443")));
  } catch (e) {
    return /*#__PURE__*/_react["default"].createElement(_app.Error, {
      error: e
    });
  }
}

InvoiceUrlSuccess.defaultProps = {
  _data: 'success',
  data: {}
};
var _default = InvoiceUrlSuccess;
exports["default"] = _default;